import {array} from 'json-bouncer'
import {FeedbackLoop} from '../../Data/FeedbackLoop'
import {decodeHttpResponse, HttpError} from '../../Data/Http'
import {update} from '../../Data/ObjectHelper'
import {Result} from '../../Data/Result'
import {Session} from '../../Data/Session'
import {productWithPriceDefinitionsDecoder} from '../../Entities/ProductWithPriceDefinitions'
import * as ProductResource from '../../Request/ProductResource'
import {ProductFinderAction} from './ProductFinderActions'
import {
    ProductFinderFeedback,
    ProductFinderRequestIdentifier
} from './ProductFinderFeedback'
import {ProductFinderState} from './ProductFinderState'

export type ProductFinderLoop =
    FeedbackLoop<ProductFinderState, ProductFinderFeedback>

export function initProductFinder(
    session: Session,
    customerId: number
): ProductFinderLoop {
    const productSearch = ''
    return {
        state: {
            productSearch,
            productSuggestions: [],
        },
        feedback: [
            fetchProductSuggestions(
                session.manufacturer.id,
                customerId,
                productSearch,
            ),
        ],
    }
}

export function productFinderReducer(
    session: Session,
    customerId: number,
    state: ProductFinderState,
    action: ProductFinderAction,
): ProductFinderLoop {
    switch (action.type) {
        case 'ProductSearchChanged':
            return {
                state: update({productSearch: action.value}, state),
                feedback: [
                    fetchProductSuggestions(
                        session.manufacturer.id,
                        customerId,
                        action.value,
                    ),
                ],
            }
        case 'ProductListResponse':
            const result =
                decodeHttpResponse(
                    array(productWithPriceDefinitionsDecoder()),
                    action.result,
                )
            return {
                state: update(
                    {
                        productSuggestions:
                            result.type === 'Ok' ? result.value : []
                    },
                    state,
                ),
                feedback: [],
            }
        case 'SelectProduct':
            return {
                state,
                feedback: [{
                    type: 'ProductSelected',
                    productWithPriceDefinitions: action.productWithPriceDefinitions,
                }],
            }
        case 'Cancel':
            return {state, feedback: [{type: 'Canceled'}]}
    }
}

function fetchProductSuggestions(
    manufacturerId: number,
    customerId: number,
    search: string
): ProductFinderFeedback {
    return {
        type: 'SendRequest',
        identifier: {
            type: 'ProductListRequest',
        },
        httpRequest:
            ProductResource.listSuggestionsForCustomerWithPriceDefinitions(
                manufacturerId,
                customerId,
                search,
            ),
    }
}

export function productFinderHttpResponseAction(
    identifier: ProductFinderRequestIdentifier,
    result: Result<HttpError, string>,
): ProductFinderAction {
    switch (identifier.type) {
        case 'ProductListRequest':
            return {
                type: 'ProductListResponse',
                result,
            }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Components/ProductFinder/ProductFinderReducer.ts